import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ReactHtmlParser from 'react-html-parser';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import 'LIBRARY/Components/Settings/DepartmentWiseRestriction/DepartmentWiseRestriction.css';
import deptWiseResponsibleIcon from "LIBRARY/CommonResources/images/departmentWiseResponsible.svg";
import searchPng from 'LIBRARY/CommonResources/images/search-stroke.png';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import { toast } from 'react-toastify';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

let apiPath = "/api/library/libraryDepartmentWiseResponsible.php"


class DepartmentWiseRestriction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All department wise responsible list
            deptWiseResponsibleListLoading: false,
            totalDeptWiseResponsibleListItems: 0,
            deptWiseResponsibleListList: {},
            pageIndex: 1,
            limit: "10",

            // filter
            searchIID: config.institute_id,
            responsibleFaculty: [],
            departmentId: "",
            isFilterLoading: false,
            statusFilter: "active",

            linkedInstituteArray: {},
            linkedInstituteArrayId: [],
            GetStreamList: {},
            loadingStreamData: false,
            GetFacultyMemberList: {},
            loadingFacultyData: false,

            // Assign Department
            addAssignDepartment: false,
            addAssignDepartmentLoading: false,

            // ADD screen field
            selectInstitute: config.institute_id,
            selectDepartment: [],
            selectResponsibleFaculty: [],
            streamDataBasedOnInstitute: [],
            loadingStreamDataBasedOnInstitute: false,

            searchTaskMember: '',
            selectedRowFacultyIds: [],
            facultyDataBasedOnInstitute: [],
            loadingFacultyDataBasedOnInstitute: false,

            // temp filter state
            searchIIDTemp: config.institute_id,
            responsibleFacultyTemp: [],
            departmentIdTemp: "",
            statusFilterTemp: "active",

            showActivitySlider: false,
            selectedIid: "",
            hoverID: "",
        };
    }

    componentDidMount() {
        this.GetAssignedInstituteList();  // assigned institute
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            'facultyId': config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetFacultyAssignedInstituteList',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult || {};
               
                let linkedInstituteData = apiResult.data || {};
                let linkedInstituteID = apiResult.linkedIidArray || [];                              

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedInstituteArrayId: linkedInstituteID
                });

                this.GetLibraryDepartmentWiseResponsibleList(); // department wise responsible list
                this.apiCallToGetFacultyMemberList();  // faculty members
                this.apiCallToGetInstituteStreamList();  // department
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.'
                });
            }
        }
    }

    // department wise responsible list
    GetLibraryDepartmentWiseResponsibleList = async () => {
        this.setState({
            deptWiseResponsibleListLoading: true
        });

        let filterResponsibleUserValue = this.state.responsibleFaculty.map(user => user.value);

        let requestData = {
            iid: this.state.searchIID,
            iidArray: this.state.linkedInstituteArrayId,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            responsibleUserID: filterResponsibleUserValue,
            departmentId: this.state.departmentId,
            status: this.state.statusFilter
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "library_GetDepartmentWiseResponsible",
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryDepartmentWiseResponsibleList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            deptWiseResponsibleListList: apiResult.data,
                            totalDeptWiseResponsibleListItems: apiResult?.totalCount,
                            deptWiseResponsibleListLoading: false
                        });
                    } else {
                        this.setState({
                            deptWiseResponsibleListList: {},
                            totalDeptWiseResponsibleListItems: 0,
                            deptWiseResponsibleListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        deptWiseResponsibleListList: {},
                        totalDeptWiseResponsibleListItems: 0,
                        deptWiseResponsibleListLoading: false
                    });
                }
            }
        }
    };

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": this.state.searchIIDTemp,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET FACULTY MEMBER for multiple linked institutes
    apiCallToGetFacultyMemberList = async () => {

        this.setState({ loadingFacultyData: true });
        let requestData = {
            iidArray: this.state.linkedInstituteArrayId,
            status: "",
            role: "",
            type: "all",
            page_index: 1,
            limit: 10,
            search: this.state.searchTaskMember
            // Inially show 10 if any search word given then remove page index and limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getMultipleInstituteRegisteredFacultyList",
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetFacultyMemberList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.data) {
                    const formattedMembers = Object.values(jsonResponse.APIResult.data).map((member) => ({
                        value: member.faculty_id, // Use `faculty_id` as the value
                        label: `${member.faculty_user_id} | ${member.faculty_fname} ${member.faculty_lname}`, // Display name
                    }));

                    this.setState({ GetFacultyMemberList: formattedMembers, loadingFacultyData: false });

                } else {
                    this.setState({
                        GetFacultyMemberList: [],
                        loadingFacultyData: false
                    });

                }
            } else {
                this.setState({ loadingFacultyData: false });
            }
        }
    };

    // on change for per page change
    handleDeptResponsibleDataChange = (pageNumber) => {
        this.setState({ pageIndex: pageNumber }, () => {
            this.GetLibraryDepartmentWiseResponsibleList();
        });
    };

    // on change for show entries per page
    resetDeptWisePerPageList = (event) => {
        this.setState({ limit: event.target.value }, () => {
            this.GetLibraryDepartmentWiseResponsibleList();
        });
    }

    // CLEAR ALL FILTER
    handleClearAllAssignDeptFilter = () => {
        this.setState({
            searchIIDTemp: config.institute_id, responsibleFacultyTemp: [], departmentIdTemp: '', limit: "10", pageIndex: 1, statusFilterTemp: "active",
            searchIID: config.institute_id, responsibleFaculty: [], departmentId: '', limit: "10", pageIndex: 1, statusFilter: "active"
        }, () => {
            this.apiCallToGetInstituteStreamList();
            this.GetLibraryDepartmentWiseResponsibleList();
        })
    };

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    handleAssignDepartment = () => {

        this.setState({
            addAssignDepartment: true
        });
        this.apiCallToGetInstituteStreamBasedOnInstituteList();
        this.apiCallToGetMemberBasedOnInstituteList();
        // const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['membership'].find(access => access === 'add');

        // if (addGrantAccess !== undefined) {
        //     this.setState({
        //         addMember: true
        //     });
        // }
        // else {
        //     this.setState({
        //         successModal: true,
        //         successModalType: 'warning',
        //         successMessage: 'This operation is restricted by the Library admin.'
        //     });
        // }
    }

    closeAddAssignDepartment = () => {
        this.setState({
            addAssignDepartment: false,
            selectInstitute: config.institute_id,
            selectDepartment: [],
            selectResponsibleFaculty: []
        });
    }

    // assign department institute field change
    handleInstituteChange = (event) => {
        this.setState({ selectInstitute: event.target.value, selectDepartment: [] }, () => {
            this.apiCallToGetInstituteStreamBasedOnInstituteList()
            // this.apiCallToGetMemberBasedOnInstituteList()
        })
    }

    // API CALL TO GET get Institute Stream List based on institute
    apiCallToGetInstituteStreamBasedOnInstituteList = async () => {
        this.setState({
            loadingStreamDataBasedOnInstitute: true,
        })
        let requestData = {
            "iid": this.state.selectInstitute,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamBasedOnInstituteList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let formattedStreamData = Object.values(apiResult.streamData).map((data) => ({
                    value: data.sid,
                    label: data.name
                }));
                this.setState({
                    streamDataBasedOnInstitute: formattedStreamData,
                    loadingStreamDataBasedOnInstitute: false,
                })
            } else {
                this.setState({
                    streamDataBasedOnInstitute: [],
                    loadingStreamDataBasedOnInstitute: false,
                })
            }
        }
    }

    // API CALL TO GET FACULTY MEMBER based on linked institute
    apiCallToGetMemberBasedOnInstituteList = async () => {

        this.setState({ loadingFacultyDataBasedOnInstitute: true });
        let requestData = {
            iidArray: this.state.linkedInstituteArrayId,
            status: "",
            role: "",
            type: "all",
            page_index: 1,
            limit: 10,
            search: this.state.searchTaskMember
            // Inially show 10 if any search word given then remove page index and limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getMultipleInstituteRegisteredFacultyList",
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetMemberBasedOnInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.data) {
                    const formattedMembers = Object.values(jsonResponse.APIResult.data).map((member) => ({
                        value: member.faculty_id, // Use `faculty_id` as the value
                        label: `${member.faculty_user_id} |  ${member.faculty_fname} ${member.faculty_lname}`, // Display name
                    }));

                    this.setState({ facultyDataBasedOnInstitute: formattedMembers, loadingFacultyDataBasedOnInstitute: false });

                } else {
                    this.setState({
                        facultyDataBasedOnInstitute: [],
                        loadingFacultyDataBasedOnInstitute: false
                    });

                }
            } else {
                this.setState({ loadingFacultyDataBasedOnInstitute: false });
            }
        }
    };

    // API call to Add assign departments
    apiCallAssignDepartment = async () => {
        this.setState({
            addAssignDepartmentLoading: true
        });

        let departmentIdValue = this.state.selectDepartment.map(department => department.value);
        let responsibleUserValue = this.state.selectResponsibleFaculty.map(user => user.value);

        let requestData = {
            iid: this.state.selectInstitute,
            iidArray: this.state.linkedInstituteArrayId,
            departmentID: departmentIdValue,
            responsibleUserID: responsibleUserValue,
            addedBy: config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_AddDepartmentWiseResponsible',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallAssignDepartment()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                        addAssignDepartment: false,
                    }, () => { this.GetLibraryDepartmentWiseResponsibleList() });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    }, () => { this.GetLibraryDepartmentWiseResponsibleList() });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while assigning department. Please try again later.',
                });
            }
        }
    }

    // METHOD TO ADD ASSIGN DEPARTMENT
    returnAddAssignDepartment = () => {
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addAssignDepartment ? 'flex' : 'none' }}>
                <div id="addMemberDataContainer">
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddAssignDepartment()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '40%' }} className="col-11">Assign Department</h5>
                    </div>

                    <div className="col-md-12 pt-2">
                        <label className="vm_custom_body10">Institute <span style={{ color: 'red' }}> *</span></label>
                        <select className="form-control"
                            name="institute"
                            id="instituteAddScreen"
                            value={this.state.selectInstitute}
                            onChange={this.handleInstituteChange}
                            style={{
                                height: '42px',
                                fontSize: "13px",
                                fontWeight: 400,
                                lineHeight: '20px',
                                fontFamily: "'Poppins', sans-serif",
                                color: '#808080',
                                borderRadius: '7px'
                            }}
                        >
                            {Object.values(this.state.linkedInstituteArray).map((member) => (
                                <option key={member?.iid} value={member?.iid}>
                                    {member?.institute_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-12 pt-2">
                        <label className="vm_custom_body10">Department<span style={{ color: 'red' }}> *</span></label>
                        <Select
                            isMulti
                            name="departmentAddScreen"
                            options={this.state.streamDataBasedOnInstitute}
                            value={this.state.selectDepartment}
                            onChange={(event) => {
                                this.setState({
                                    selectDepartment: event || [], // Handle empty selection
                                })
                            }}
                            isLoading={this.state.loadingStreamDataBasedOnInstitute} // Show loading spinner while fetching
                            placeholder="Select Department"
                            styles={{
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    fontWeight: '400', // Use fontWeight for normal text

                                }),
                                control: (base) => ({
                                    ...base,
                                    minHeight: 42, // Minimum height for the control area
                                    height: 'auto', // Allow control to grow dynamically,
                                    fontSize: "13px",
                                    fontWeight: 400,
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? '#333' : '#555',
                                }),
                            }}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => (this.state.loadingStreamDataBasedOnInstitute ? "Loading..." : "No options found")}
                        />
                    </div>

                    <div className="col-md-12 pt-2">
                        <label className="vm_custom_body10">Responsible Faculty<span style={{ color: 'red' }}> *</span></label>
                        <Select
                            isMulti
                            name="employeeAddScreen"
                            options={this.state.facultyDataBasedOnInstitute}
                            value={this.state.selectResponsibleFaculty}
                            onChange={(event) => {
                                this.setState({
                                    selectResponsibleFaculty: event || [], // Handle empty selection
                                })
                            }}
                            placeholder="Search by Employee Name"
                            onInputChange={(inputValue) => {
                                this.setState({ searchTaskMember: inputValue }, () => {

                                    this.apiCallToGetMemberBasedOnInstituteList(); // Trigger the API call after updating the search term
                                }, 200);
                            }}
                            isSearchable
                            isLoading={this.state.loadingFacultyDataBasedOnInstitute} // Show loading spinner while fetching
                            styles={{
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    fontWeight: '400', // Use fontWeight for normal text

                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    fontWeight: '400', // Use fontWeight for normal text
                                }),
                                control: (base) => ({
                                    ...base,
                                    minHeight: 42, // Minimum height for the control area
                                    height: 'auto', // Allow control to grow dynamically,
                                    fontSize: "13px",
                                    fontWeight: 400,
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? '#333' : '#555',
                                }),
                            }}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => (this.state.loadingFacultyDataBasedOnInstitute ? "Loading..." : "No options found")}
                        />
                    </div>

                    <div id="addAccessFooter" className="modal-footer pt-3">
                        <button className="btn custom-btn" style={{ fontSize: '14px', borderRadius: '7px', borderColor: '#0465AC' }} onClick={() => this.closeAddAssignDepartment()}>Cancel</button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }}
                            disabled={this.state.selectDepartment.length == 0 || this.state.selectResponsibleFaculty.length == 0}
                            onClick={() => this.apiCallAssignDepartment()}
                        >Add</button>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO SELECT SINGLE EMPLOYEE
    selectSingleUser = (userID) => {
        this.setState((prevState) => {
            const selectedRowFacultyIds = prevState.selectedRowFacultyIds.includes(userID)
                ? prevState.selectedRowFacultyIds.filter((rowId) => rowId !== userID) // Remove if already selected
                : [...prevState.selectedRowFacultyIds, userID]; // Add if not selected

            return { selectedRowFacultyIds };
        });
    }

    // METHOD TO SELECT ALL USERS
    selectAllUsers = () => {
        this.setState((prevState) => {
            // Check if all rows are selected or not
            const allRowsSelected = prevState.selectedRowFacultyIds.length === Object.keys(this.state.deptWiseResponsibleListList).length;

            // If all rows are selected, uncheck all; otherwise, check all
            return {
                selectedRowFacultyIds: allRowsSelected
                    ? []  // Deselect all if already selected
                    : Object.values(this.state.deptWiseResponsibleListList).map((data) => data.uniqueId), // Select all
            };
        });
    }

    // API call to Update assign department faculty status
    updateAssignDepartmentStatus = async (status) => {
        let requestData = {
            "iid": config.institute_id,
            "iidArray": this.state.linkedInstituteArrayId,
            "UniqueIdArray": this.state.selectedRowFacultyIds,
            "updatedBy": config.faculty_id,
            "status": status
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateDepartmentWiseResponsible',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.updateAssignDepartmentStatus()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    this.setState({
                        selectedRowFacultyIds: []
                    });
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.GetLibraryDepartmentWiseResponsibleList();
                } else {
                    this.setState({
                        selectedRowFacultyIds: []
                    });
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                    // toast.warn(apiResult.message, {
                    //     position: "top-right",
                    //     autoClose: 2000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    // });
                }
            } else {
                toast.error('Something went wrong while updating status. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // list filter
    ApplyFilter = async () => {
        this.setState({
            searchIID: this.state.searchIIDTemp, responsibleFaculty: this.state.responsibleFacultyTemp, departmentId: this.state.departmentIdTemp, pageIndex: 1, statusFilter: this.state.statusFilterTemp
        }, () => { this.GetLibraryDepartmentWiseResponsibleList() })
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {
        return (
            <>
                <RoutingMenu activeScreen="departmentWiseResponsible" />

                <div className="DepartmentWiseResponsibleContainer">
                    {/* page header */}
                    <div className="deptWiseResponsibleHeader">
                        <div className='backToSetting'>
                            <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeDepartmentWiseResponsible()} >
                                <FontAwesomeIcon className="viewGrievance-icon" icon={["fa", "angle-left"]} />
                            </button>
                            <h3 style={{ fontSize: "24px" }}>Department-Wise Responsible</h3>
                        </div>
                        <button className="btn btn-outline-primary assign-department" onClick={() => this.handleAssignDepartment()} >
                            <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;Assign Department
                        </button>
                    </div>

                    {/* list filter */}
                    <div>
                        <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                            <div style={{ width: '100%' }}>
                                {/* <form style={{ width: '100%' }}> */}
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        {/* Based on Responsible Faculty */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="ProjectID" className="vm_custom_body10">Faculty</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <Select
                                                    isMulti
                                                    options={this.state.GetFacultyMemberList}
                                                    value={this.state.responsibleFacultyTemp}
                                                    className="basic-multi-select-filter"
                                                    onChange={(event) => {
                                                        if (event.length > 5) {
                                                            toast.warn('You can only select up to 5 faculty members.', {
                                                                position: "top-right",
                                                                autoClose: 2000,
                                                                hideProgressBar: false,
                                                                closeOnClick: true,
                                                                pauseOnHover: true,
                                                                draggable: true,
                                                                progress: undefined,
                                                            });
                                                        } else {
                                                            this.setState({
                                                                responsibleFacultyTemp: event || [], // Handle empty selection
                                                            });
                                                        }
                                                    }}
                                                    onInputChange={(inputValue) => {
                                                        this.setState({ searchTaskMember: inputValue, selectedRowFacultyIds: [] }, () => {

                                                            this.apiCallToGetFacultyMemberList(); // Trigger the API call after updating the search term
                                                        }, 200);
                                                    }}
                                                    placeholder="Search Responsible Faculty"
                                                    isSearchable
                                                    isLoading={this.state.loadingFacultyData} // Show loading spinner while fetching
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            width: '100%',
                                                            minHeight: 42, // Minimum height for the control area
                                                            height: 'auto', // Allow control to grow dynamically
                                                        }),
                                                        multiValue: (base) => ({
                                                            ...base,
                                                            backgroundColor: 'none',
                                                            borderRadius: '5px',
                                                            border: '1px solid #c4c5c5',
                                                            fontSize: '13px',
                                                            fontWeight: '400',
                                                            color: '#808080',
                                                            display: 'inline-flex',
                                                            margin: '2px',
                                                            whiteSpace: 'nowrap',
                                                        }),
                                                        multiValueContainer: (base) => ({
                                                            ...base,
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            overflowX: 'auto', // Horizontal scroll when values overflow
                                                            minHeight: 42, // Ensure consistent height when values are selected
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            fontSize: '13px',
                                                            fontWeight: '400',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '13px',
                                                            fontWeight: '400',
                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                            color: state.isSelected ? '#333' : '#555',
                                                        }),
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => (this.state.loadingFacultyData ? "Loading..." : "No options found")}
                                                />
                                            </div>
                                        </div>

                                        {/* Based on Institute */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="ProjectID" className="vm_custom_body10">Institute</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <select
                                                    className="form-control formControlContentTask vm_custom_body"
                                                    style={{
                                                        width: 'auto',
                                                        height: '42px',
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        fontFamily: "'Poppins', sans-serif",
                                                        color: '#808080',
                                                        borderRadius: '7px'
                                                    }}
                                                    id="projectStatus"
                                                    onChange={(event) => {
                                                        this.setState({ searchIIDTemp: event.target.value, departmentIdTemp: "", selectedRowFacultyIds: [] }, () => {
                                                            this.apiCallToGetInstituteStreamList()
                                                        })
                                                    }} // Attach handler here
                                                    value={this.state.searchIIDTemp} // Bind dropdown value to state

                                                >
                                                    {Object.values(this.state.linkedInstituteArray).map((member) => (
                                                        <option key={member?.iid} value={member?.iid}>
                                                            {member?.institute_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Based on Department */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="ProjectID" className="vm_custom_body10">Department</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <select
                                                    className="form-control formControlContentTask vm_custom_body"
                                                    style={{
                                                        width: 'auto',
                                                        height: '42px',
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        fontFamily: "'Poppins', sans-serif",
                                                        color: '#808080',
                                                        borderRadius: '7px'
                                                    }}
                                                    id="projectStatus"
                                                    onChange={(event) => {
                                                        this.setState({ departmentIdTemp: event.target.value, selectedRowFacultyIds: [] })
                                                    }} // Attach handler here
                                                    value={this.state.departmentIdTemp} // Bind dropdown value to state

                                                >
                                                    <option value="">Select Department</option>
                                                    {Object.values(this.state.GetStreamList).map((stream) => (
                                                        <option key={stream?.sid} value={stream?.sid} title={stream?.name} >
                                                            {stream?.name?.length > 30 ? `${stream?.name.substring(0, 10)}...` : stream?.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Based on Status */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="ProjectID" className="vm_custom_body10">Status</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <select
                                                    className="form-control formControlContentTask vm_custom_body"
                                                    style={{
                                                        width: 'auto',
                                                        height: '42px',
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        fontFamily: "'Poppins', sans-serif",
                                                        color: '#808080',
                                                        borderRadius: '7px'
                                                    }}
                                                    id="projectStatus"
                                                    onChange={(event) => {
                                                        this.setState({ statusFilterTemp: event.target.value, selectedRowFacultyIds: [] })
                                                    }} // Attach handler here
                                                    value={this.state.statusFilterTemp} // Bind dropdown value to state

                                                >
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => this.ApplyFilter()}>
                                        Apply
                                    </button>
                                </div>
                                {/* </form> */}
                            </div>
                        </div>
                        {
                            (this.state.searchIIDTemp !== config.institute_id || this.state.statusFilterTemp !== "active" || this.state.responsibleFacultyTemp.length !== 0 || this.state.departmentIdTemp !== "") &&
                            <div className='filter-apply'>
                                <p className='vm_custom_body5'>Filters are applied.</p>
                                <p className="clear-all vm_custom_body5" onClick={this.handleClearAllAssignDeptFilter}>Clear All</p>
                            </div>
                        }
                    </div>

                    {/* table list view */}
                    <div className="table-responsive col-md-12 scrollable-div" style={{ width: '100%', maxHeight: '60vh' }}>
                        <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                            <thead
                                style={{
                                    backgroundColor: "#F5F8FA",
                                    position: 'sticky',
                                    top: '-1%',  // Ensure sticky behavior
                                    zIndex: 1, // Make sure it stays above table content
                                    borderBottom: '1px solid #E0E8EF', // Optional border for separation
                                }}
                            >
                                <tr>
                                    <th className='vm_custom_title5' style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                        <input
                                            type="checkbox"
                                            onChange={this.selectAllUsers}  // Handle Select All logic
                                            checked={Object.keys(this.state.deptWiseResponsibleListList).length > 0 &&
                                                (Object.keys(this.state.deptWiseResponsibleListList).length === this.state.selectedRowFacultyIds.length)}  // Check if all rows are selected
                                            style={{ marginRight: 5 }}
                                        />
                                    </th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Sr . No</p></th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Faculty</p></th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Institute</p></th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Allocated Department</p></th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Status</p></th>
                                    <th style={{ padding: '12px 12px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}><p className='vm_custom_body16'>Last Modified By</p></th>
                                </tr>
                                {
                                    this.state.selectedRowFacultyIds.length > 0 &&
                                    <tr style={{ backgroundColor: "#eff7ff" }}>
                                        <th colSpan="13" style={{ padding: '10px' }}>
                                            <div className="">
                                                <span id="assignDepartmentStatus" title="Mark as active" onClick={() => this.updateAssignDepartmentStatus('active')}>
                                                    Active
                                                </span>
                                                <span id="assignDepartmentStatus" title="Mark as inactive" onClick={() => this.updateAssignDepartmentStatus('inactive')}>
                                                    Inactive
                                                </span>
                                            </div>
                                        </th>
                                    </tr>
                                }
                            </thead>

                            {
                                this.state.deptWiseResponsibleListLoading ? <ButtonLoader /> : (
                                    <tbody style={{ backgroundColor: '#FFF', overflow: 'auto' }}>
                                        {Object.keys(this.state.deptWiseResponsibleListList).length > 0 ?
                                            (Object.values(this.state.deptWiseResponsibleListList).map((data, index) => (
                                                <tr key={index}>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => this.selectSingleUser(data.uniqueId)}  // When clicked, toggle the individual checkbox
                                                            checked={this.state.selectedRowFacultyIds.includes(data.uniqueId)}  // Check if the current row is selected
                                                        />
                                                    </td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{
                                                        this.state.limit === 'all' ? index + 1 :
                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                    }
                                                    </td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', cursor: 'pointer' }}>{
                                                        <p className='vm_custom_body5'>{data.ResponsibleName}</p>
                                                    }</td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body5'>{data.InstituteName}</p>
                                                    </td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body5'>{data.DepartmentName}</p>
                                                    </td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body5' style={{ color: data.Status === 'active' ? 'green' : 'red' }}>{data.Status == 'active' ? 'Active' : 'Inactive'}</p>
                                                    </td>
                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', cursor: "pointer", color: data.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                        onMouseEnter={() => this.setState({ hoverID: data.uniqueId })}
                                                        onMouseLeave={() => this.setState({ hoverID: "" })}
                                                        onClick={() => this.openActivitySlider(data.uniqueId)}>
                                                        <p className='vm_custom_body5'>
                                                            {data.updatedByName ? (
                                                                <div className="d-flex flex-column">
                                                                    <div>{data.updatedByName} ({data.last_updated_by_ERP}) | {data.UpdatedOn}</div>
                                                                </div>
                                                            ) : (
                                                                <div className="d-flex flex-column">
                                                                    <div>{data.issuedByName} ({data.added_by_ERP}) | {data.IssuedOn}</div>
                                                                </div>
                                                            )}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))) :
                                            <tr style={{ height: '27.5rem' }}>
                                                <td
                                                    className="table-rows vm_custom_body5"
                                                    colSpan={9}
                                                    style={{
                                                        textAlign: 'center', // Horizontally center
                                                        verticalAlign: 'middle', // Vertically center
                                                        height: '100%', // Ensure the cell takes the height of the row
                                                    }}
                                                >
                                                    <p
                                                        className="vm_custom_body5"
                                                        style={{
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        No data found for Department wise responsible.
                                                    </p>
                                                </td>
                                            </tr>

                                        }
                                    </tbody>
                                )
                            }

                            <tfoot style={{ position: 'sticky', bottom: '-1%' }}>
                                <tr>
                                    <td colSpan="9" style={{ padding: 0, border: 'none', alignItems: 'center' }}>
                                        {/* Pagination div */}
                                        <div style={{ display: 'flex', backgroundColor: "#F5F8FA", height: '42px', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', borderRadius: '0.69px', paddingRight: '16px' }}>
                                            <div className="ml-3">
                                                <select style={{
                                                    width: 'auto',
                                                    borderRadius: 'none',
                                                    backgroundColor: '#F5F8FA',
                                                    border: 'none',
                                                    outline: 'none',
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: '28px'
                                                }}
                                                    value={this.state.limit}
                                                    onChange={this.resetDeptWisePerPageList}
                                                >
                                                    <option value={10} className='footer-select-dropdown-values'>Entries per page: 10</option>
                                                    <option value={25} className='footer-select-dropdown-values'>Entries per page: 25</option>
                                                    <option value={40} className='footer-select-dropdown-values'>Entries per page: 40</option>
                                                    <option value={100} className='footer-select-dropdown-values'>Entries per page: 100</option>
                                                    <option value={250} className='footer-select-dropdown-values'>Entries per page: 250</option>
                                                </select>
                                            </div>

                                            <div id="paginationContainer" >
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalDeptWiseResponsibleListItems}
                                                    onChange={this.handleDeptResponsibleDataChange}
                                                    pageRangeDisplayed={4}
                                                />
                                            </div>

                                            <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <label className="footer-select-dropdown-values m-0" style={{ lineHeight: '14px' }}>Total Records :</label>
                                                <label className="footer-select-dropdown-values m-0" style={{ fontSize: '14px', lineHeight: '14px', fontWeight: 600 }}>{this.state.totalDeptWiseResponsibleListItems}</label>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </div >

                </div>

                {
                    this.returnAddAssignDepartment()
                }

                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["department_wise_responsible_added", "Department_wise_responsible_status_updated"]}
                    />
                }
            </>
        )
    }
}

export default DepartmentWiseRestriction;